import { jsx as _jsx } from "react/jsx-runtime";
import { format } from 'date-fns';
import { cs } from 'date-fns/locale';
import { sizes } from '../../../../const/sizes';
import { Text } from '../../../Text/Text';
import { GridContainer } from '../../../layout/GridContainer';
import { StyledCalendarDay } from './StyledCalendarDay';
import { getDayTextColor } from './utils/getDayTextColor';
export const CalendarDays = ({ calendarDays, onSelectDate, onCloseCalendar, }) => {
    return (_jsx(GridContainer, { spacingTop: '1', columns: 'repeat(7, 1fr)', rows: 'auto', gap: '1/2', minHeight: sizes.calendar.daysMinHeight, children: calendarDays.map(({ day, isCurrentDay, isOutOfCurrentMonth, isSelectedDay, isBlockedDay, }) => {
            const dayNumber = format(day, 'd', { locale: cs });
            const handleSelectDate = () => {
                onSelectDate(day);
                onCloseCalendar();
            };
            const key = day.toString();
            const textColor = getDayTextColor({
                isOutOfCurrentMonth,
                isSelectedDay,
                isBlockedDay,
            });
            const textVariant = !isBlockedDay ? 's2' : 'b2';
            return (_jsx(StyledCalendarDay, { $isCurrentDay: isCurrentDay, $isSelectedDay: isSelectedDay, $isBlockedDay: isBlockedDay, disabled: isBlockedDay, onClick: handleSelectDate, children: _jsx(Text, { align: 'center', variant: textVariant, colorOverride: textColor, children: dayNumber }) }, key));
        }) }));
};
